import React, { useEffect } from "react";
import * as S from "./styles";
import { BsCheckCircle } from "react-icons/bs";
import { FutButton } from "@/components/FutButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Thanks() {
  const navigate = useNavigate();
  const {changeToken} = useAuth()
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    if (token){
      changeToken(token)
    }
    
  },[])
  return (
    <S.ThanksWrapper>
      <S.ThanksBox>
        <BsCheckCircle />
        <h2>Agradecemos pela sua compra!</h2>
        <p>Para começar a utilizar nossos serviços clique no botão abaixo!</p>
        <FutButton onClick={() => navigate("/dashboard")}>Começar agora</FutButton>
      </S.ThanksBox>
    </S.ThanksWrapper>
  );
}
